import React from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const Footer=()=> {
  return (
    <footer className="bg-ube-dark text-sand-light pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="space-y-6">
            <Link to="/" className="font-serif text-3xl font-semibold text-white tracking-tight">
              UBEA<span className="text-coral">.</span>
            </Link>
            <p className="text-lavender-light text-sm max-w-xs leading-relaxed">
              Philippine ube from family farms, grown and dried in the Philippines — peeled, steamed, and powdered. Shipped from Manila and arriving through the Port of Los Angeles, California, then delivered across the US — worldwide on request.
            </p>
            <div className="flex gap-4">
              <Link to="/privacy" className="inline-block text-sm text-lavender-light hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="inline-block text-sm text-lavender-light hover:text-white transition-colors">Terms</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;